import { Component, OnInit, Input, ViewChild, ElementRef, ViewEncapsulation, OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'mem-undraw-img',
  templateUrl: './undraw-img.component.html',
  styleUrls: ['./undraw-img.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UnDrawImgComponent implements OnInit, OnChanges {

  @Input() file;
  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.loadSVG();
  }

  ngOnChanges() {
    this.loadSVG();
  }

  // private

  private loadSVG() {
    const options: any = {
      headers: new HttpHeaders({
        'Accept': 'text/html, application/xhtml+xml, */*',
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      responseType: 'text'
    };

    this.http.get(`assets/images/${this.file}.svg`, options).subscribe(data => {
      this.svgContainer.nativeElement.innerHTML = '';
      this.svgContainer.nativeElement.insertAdjacentHTML('beforeend', data);
    });
  }

}
